import styled from 'styled-components/macro'

export const Container = styled.div`
  > div {
    margin-bottom: 25px;
  }
`
